'use client'

import { LaunchdarklyProvider } from '@/shared/libs/launchdarkly/client'
import { useLaunchdarklyIdentify } from '@/shared/libs/launchdarkly/client/hooks/use-launchdarkly-identify'
import { useLaunchdarklyReady } from '@/shared/libs/launchdarkly/client/hooks/use-launchdarkly-ready'
import { useLaunchdarklyVariation } from '@/shared/libs/launchdarkly/client/hooks/use-launchdarkly-variation'
import { FeatureFlagContext } from '@/shared/providers/feature-flag/context'
import type { WithChildren } from '@/types/components'

export const FeatureFlagProvider = ({ children }: WithChildren) => (
  <LaunchdarklyProvider>
    <FeatureFlagContextProvider>{children}</FeatureFlagContextProvider>
  </LaunchdarklyProvider>
)

const FeatureFlagContextProvider = ({ children }: WithChildren) => {
  const isReady = useLaunchdarklyReady()
  const variation = useLaunchdarklyVariation()
  const identify = useLaunchdarklyIdentify()

  return (
    <FeatureFlagContext.Provider value={{ isReady, variation, identify }}>
      {children}
    </FeatureFlagContext.Provider>
  )
}
